export enum ResponseStatus {
  COOKIRE_REQUIRED = "S006",
  INVALID_TOKEN = "F103",
  JWT_TOKEN_EXPIRED = "F104",
  ATK_NOT_EXIST = "F105",
  RTK_NOT_EXIST = "F108",
}
